import { render, staticRenderFns } from "./ModalAnular.vue?vue&type=template&id=6b01e000"
import script from "./ModalAnular.vue?vue&type=script&lang=js"
export * from "./ModalAnular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports